<template>
    <div>
        <div class="columns">
            <div class="column">
                <b-field label="Role Here" label-position="inside">
                    <b-select v-model="link.role" expanded>
                        <option :value="null">Same as type</option>
                        <option v-for="role in roles" :value="role.value" :key="role.value">{{role.label}}</option>
                    </b-select>
                </b-field>
            </div>
            <div class="column">
                <b-field label="Label" label-position="inside">
                    <b-input v-model="link.label" placeholder="Optional"></b-input>
                </b-field>
            </div>
        </div>
        <div class="has-text-right">
            <b-button type="is-primary" size="is-small" @click="$emit('attach')">
                <i class="fas fa-link mr-2"></i>Attach
            </b-button>
        </div>
    </div>
</template>

<script>
    import {TYPES} from "@/components/contact_meta";

    /**
     * The inline role/label step shown under a picked contact. Split out only
     * so the picker can render it under both the suggestions and the search
     * results without duplicating the markup.
     */
    export default {
        name: 'AttachFields',
        props: {
            link: {
                type: Object,
                required: true
            }
        },
        data: function () {
            return {
                roles: TYPES
            };
        }
    };
</script>
